import axios from 'axios'
import api from './api'
import Vue from 'vue';
let Base64 = require('js-base64').Base64;
import { Toast } from 'vant';
import qs from "qs";
import { getServerLang } from '../common/locale';
// ============================================================
// 站点域名：换域名只需要改这一行
// 用途：静态资源前缀（头像、相册、视频封面等，模板里通过 $baseURL 使用）
// ============================================================
const SITE_HOST = 'https://kongjiang20660914.8822128.site/';
const baseURL = SITE_HOST;
Vue.use(Toast);
//创建axios实例对象
const  instance = axios.create({
    // baseURL: 'https://gxcg01.buzz/api', //服务器地址
     // 接口地址：默认同域 /api（推荐；语言 Cookie 与 lang 头同源最稳）
     // 若接口单独部署在别的域名，改成绝对地址，例如： baseURL: SITE_HOST + 'api'
     baseURL: '/api', //服务器地址
    timeout: 5000, //默认超时时长
    withCredentials: true, 
})

//请求拦截器
instance.interceptors.request.use(config=>{
    if(config.method === "post"){
        config.headers = {
            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8', // 设置跨域头部
        }
    }
    // 语言：无论是否登录，都把当前站点语言带给后端
    // 后端按 think_var cookie（detect_var=lang）加载 application/api/lang/<lang>.php，
    // 因此接口的成功/失败提示会跟随前端语言返回
    const lang = getServerLang();
    document.cookie = `think_var=${lang}; path=/`;
    config.headers = {
        ...config.headers,
        'lang': lang,
    }
    if(localStorage.getItem('token')){
        config.headers = {
            ...config.headers,
            'token': Base64.encode(localStorage.getItem('token')),
        }
    }
    return config
},err=>{
    console.error('请求失败',err)
})

//响应拦截器
instance.interceptors.response.use(res=>{
    //此处对响应数据做处理
    if(res.data.msg === "鉴权错误"){
        // localStorage.clear();
        // this.$router.push({path:'/Login'})
    }
    return res //该返回对象会传到请求方法的响应对象中
},err=>{
    // 响应错误处理
    return Promise.reject(err);
})

//封装axios请求方法，参数为配置对象
//option = {method,url,params} method为请求方法，url为请求接口，params为请求参数
async function http(option = {}) {
    let result = null
    if(option.method === 'get' || option.method === 'delete'){
        //处理get、delete请求
        await instance[option.method](
            api[option.url],
            {params: option.data}
        ).then(res=>{
            result = res.data
            result.data = JSON.parse(Base64.decode(result.data));
        }).catch(err=>{
            result = err
        })
    }else if(option.method === 'post' || option.method === 'put'){
        //处理post、put请求
        await instance[option.method](
                api[option.url],
            qs.stringify(option.data)
        ).then(res=>{
            result = res.data;
            result.data = JSON.parse(Base64.decode(result.data));
        }).catch(err=>{
            result = err
        })
    }
    return result
}

export {http,baseURL}

